export const COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'JP', name: 'Japan' },
  { code: 'CN', name: 'China' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'KR', name: 'South Korea' },
  { code: 'SG', name: 'Singapore' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'TH', name: 'Thailand' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'PH', name: 'Philippines' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'IN', name: 'India' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'QA', name: 'Qatar' },
  { code: 'VG', name: 'British Virgin Islands' },
];

export const CURRENCIES = [
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
  { code: 'TWD', name: 'Taiwan Dollar', symbol: 'NT$' },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp' },
  { code: 'PHP', name: 'Philippine Peso', symbol: '₱' },
  { code: 'VND', name: 'Vietnamese Dong', symbol: '₫' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: '﷼' },
  { code: 'OTH', name: 'Others', symbol: '' },
];

export const TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET) - New York' },
  { value: 'America/Chicago', label: 'Central Time (CT) - Chicago' },
  { value: 'America/Denver', label: 'Mountain Time (MT) - Denver' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT) - Los Angeles' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT) - Anchorage' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST) - Honolulu' },
  { value: 'America/Toronto', label: 'Eastern Time - Toronto' },
  { value: 'America/Vancouver', label: 'Pacific Time - Vancouver' },
  { value: 'America/Halifax', label: 'Atlantic Time - Halifax' },
  { value: 'Europe/London', label: 'Greenwich Mean Time (GMT) - London' },
  { value: 'Europe/Dublin', label: 'Greenwich Mean Time (GMT) - Dublin' },
  { value: 'Europe/Paris', label: 'Central European Time (CET) - Paris' },
  { value: 'Europe/Berlin', label: 'Central European Time (CET) - Berlin' },
  { value: 'Europe/Rome', label: 'Central European Time (CET) - Rome' },
  { value: 'Europe/Madrid', label: 'Central European Time (CET) - Madrid' },
  { value: 'Europe/Amsterdam', label: 'Central European Time (CET) - Amsterdam' },
  { value: 'Europe/Brussels', label: 'Central European Time (CET) - Brussels' },
  { value: 'Europe/Vienna', label: 'Central European Time (CET) - Vienna' },
  { value: 'Europe/Zurich', label: 'Central European Time (CET) - Zurich' },
  { value: 'Europe/Stockholm', label: 'Central European Time (CET) - Stockholm' },
  { value: 'Europe/Oslo', label: 'Central European Time (CET) - Oslo' },
  { value: 'Europe/Copenhagen', label: 'Central European Time (CET) - Copenhagen' },
  { value: 'Europe/Helsinki', label: 'Eastern European Time (EET) - Helsinki' },
  { value: 'Europe/Warsaw', label: 'Central European Time (CET) - Warsaw' },
  { value: 'Europe/Prague', label: 'Central European Time (CET) - Prague' },
  { value: 'Europe/Budapest', label: 'Central European Time (CET) - Budapest' },
  { value: 'Europe/Bucharest', label: 'Eastern European Time (EET) - Bucharest' },
  { value: 'Europe/Sofia', label: 'Eastern European Time (EET) - Sofia' },
  { value: 'Europe/Athens', label: 'Eastern European Time (EET) - Athens' },
  { value: 'Europe/Istanbul', label: 'Turkey Time (TRT) - Istanbul' },
  { value: 'Europe/Moscow', label: 'Moscow Standard Time (MSK) - Moscow' },
  { value: 'Europe/Kiev', label: 'Eastern European Time (EET) - Kiev' },
  { value: 'Asia/Tokyo', label: 'Japan Standard Time (JST) - Tokyo' },
  { value: 'Asia/Seoul', label: 'Korea Standard Time (KST) - Seoul' },
  { value: 'Asia/Shanghai', label: 'China Standard Time (CST) - Shanghai' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong Time (HKT) - Hong Kong' },
  { value: 'Asia/Taipei', label: 'China Standard Time (CST) - Taipei' },
  { value: 'Asia/Singapore', label: 'Singapore Standard Time (SGT) - Singapore' },
  { value: 'Asia/Kuala_Lumpur', label: 'Malaysia Time (MYT) - Kuala Lumpur' },
  { value: 'Asia/Bangkok', label: 'Indochina Time (ICT) - Bangkok' },
  { value: 'Asia/Jakarta', label: 'Western Indonesia Time (WIB) - Jakarta' },
  { value: 'Asia/Manila', label: 'Philippines Standard Time (PST) - Manila' },
  { value: 'Asia/Ho_Chi_Minh', label: 'Indochina Time (ICT) - Ho Chi Minh City' },
  { value: 'Asia/Kolkata', label: 'India Standard Time (IST) - Kolkata' },
  { value: 'Asia/Karachi', label: 'Pakistan Standard Time (PKT) - Karachi' },
  { value: 'Asia/Dhaka', label: 'Bangladesh Standard Time (BST) - Dhaka' },
  { value: 'Asia/Colombo', label: 'Sri Lanka Standard Time (SLST) - Colombo' },
  { value: 'Australia/Sydney', label: 'Australian Eastern Time (AET) - Sydney' },
  { value: 'Australia/Melbourne', label: 'Australian Eastern Time (AET) - Melbourne' },
  { value: 'Australia/Brisbane', label: 'Australian Eastern Time (AET) - Brisbane' },
  { value: 'Australia/Perth', label: 'Australian Western Time (AWT) - Perth' },
  { value: 'Australia/Adelaide', label: 'Australian Central Time (ACT) - Adelaide' },
  { value: 'Pacific/Auckland', label: 'New Zealand Standard Time (NZST) - Auckland' },
  { value: 'America/Sao_Paulo', label: 'Brazil Time (BRT) - São Paulo' },
  { value: 'America/Buenos_Aires', label: 'Argentina Time (ART) - Buenos Aires' },
  { value: 'America/Santiago', label: 'Chile Standard Time (CLT) - Santiago' },
  { value: 'America/Bogota', label: 'Colombia Time (COT) - Bogotá' },
  { value: 'America/Lima', label: 'Peru Time (PET) - Lima' },
  { value: 'America/Mexico_City', label: 'Central Standard Time (CST) - Mexico City' },
  { value: 'Africa/Johannesburg', label: 'South Africa Standard Time (SAST) - Johannesburg' },
  { value: 'Africa/Cairo', label: 'Eastern European Time (EET) - Cairo' },
  { value: 'Africa/Lagos', label: 'West Africa Time (WAT) - Lagos' },
  { value: 'Africa/Nairobi', label: 'East Africa Time (EAT) - Nairobi' },
  { value: 'Africa/Casablanca', label: 'Western European Time (WET) - Casablanca' },
  { value: 'Asia/Dubai', label: 'Gulf Standard Time (GST) - Dubai' },
  { value: 'Asia/Riyadh', label: 'Arabia Standard Time (AST) - Riyadh' },
  { value: 'Asia/Qatar', label: 'Arabia Standard Time (AST) - Qatar' },
  { value: 'Asia/Kuwait', label: 'Arabia Standard Time (AST) - Kuwait' },
  { value: 'Asia/Bahrain', label: 'Arabia Standard Time (AST) - Bahrain' },
  { value: 'Asia/Muscat', label: 'Gulf Standard Time (GST) - Muscat' },
  { value: 'Asia/Amman', label: 'Eastern European Time (EET) - Amman' },
  { value: 'Asia/Beirut', label: 'Eastern European Time (EET) - Beirut' },
  { value: 'Asia/Jerusalem', label: 'Israel Standard Time (IST) - Jerusalem' },
];

export const PHONE_REGION_CODES = [
  { code: '+1', country: 'United States/Canada', flag: '🇺🇸' },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧' },
  { code: '+49', country: 'Germany', flag: '🇩🇪' },
  { code: '+33', country: 'France', flag: '🇫🇷' },
  { code: '+39', country: 'Italy', flag: '🇮🇹' },
  { code: '+34', country: 'Spain', flag: '🇪🇸' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭' },
  { code: '+43', country: 'Austria', flag: '🇦🇹' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪' },
  { code: '+47', country: 'Norway', flag: '🇳🇴' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰' },
  { code: '+358', country: 'Finland', flag: '🇫🇮' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹' },
  { code: '+30', country: 'Greece', flag: '🇬🇷' },
  { code: '+48', country: 'Poland', flag: '🇵🇱' },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿' },
  { code: '+36', country: 'Hungary', flag: '🇭🇺' },
  { code: '+81', country: 'Japan', flag: '🇯🇵' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷' },
  { code: '+86', country: 'China', flag: '🇨🇳' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰' },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
  { code: '+66', country: 'Thailand', flag: '🇹🇭' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭' },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳' },
  { code: '+91', country: 'India', flag: '🇮🇳' },
  { code: '+61', country: 'Australia', flag: '🇦🇺' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷' },
  { code: '+56', country: 'Chile', flag: '🇨🇱' },
  { code: '+27', country: 'South Africa', flag: '🇿🇦' },
  { code: '+971', country: 'UAE', flag: '🇦🇪' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦' },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼' },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭' },
  { code: '+968', country: 'Oman', flag: '🇴🇲' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷' },
  { code: '+7', country: 'Russia', flag: '🇷🇺' },
];

// COUNTRIES already defined above - will be reused for employee country selection

export const getCountryByCode = (code: string) => COUNTRIES.find(c => c.code === code);
export const getCurrencyByCode = (code: string) => CURRENCIES.find(c => c.code === code);
export const getTimezoneByValue = (value: string) => TIMEZONES.find(t => t.value === value);
export const getPhoneRegionByCode = (code: string) => PHONE_REGION_CODES.find(p => p.code === code);